import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
	path: '/grouping',
	name: 'Grouping',
	meta: {
		title: '分组',
		keepAlive: false
	},
	component: Empty,
	redirect: '/grouping',
	children: [
		{
			path: '',
			name: 'Grouping',
			meta: {
				keepAlive: false
			},
			component: resolve => require(['@/views/studentMangage/grouping/Index.vue'], resolve)
		},
		{
			path: 'grouping_student_list',
			name: 'GroupingStudentsManage',
			meta: {
				title: '学员管理',
				keepAlive: false
			},
			component: resolve => require(['@/views/studentMangage/groupingStudentsManage/Index.vue'], resolve),
		}
	]
}
